import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Select = React.forwardRef(
  (
    {
      className: additionalClassName = null,
      children,
      withBorder = false,
      error = null,
      requiredStyle = false,
      ...otherProps
    },
    ref
  ) => {
    const className = classNames('select', {
      'select_with-border': withBorder,
      select_required: requiredStyle,
      select_invalid: error,
    });

    const innerClassName = classNames('select__inner', additionalClassName);

    return (
      <div className={className}>
        <select className={innerClassName} {...otherProps} ref={ref}>
          {children}
        </select>
        {error && <span className="select__error">{error}</span>}
      </div>
    );
  }
);

Select.displayName = 'Select';

Select.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  withBorder: PropTypes.bool,
  error: PropTypes.string,
  requiredStyle: PropTypes.bool,
};

export default Select;
